import { render, staticRenderFns } from "./CreateHelp.vue?vue&type=template&id=5f0d2530&scoped=true"
import script from "./CreateHelp.vue?vue&type=script&lang=js"
export * from "./CreateHelp.vue?vue&type=script&lang=js"
import style0 from "./CreateHelp.vue?vue&type=style&index=0&id=5f0d2530&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0d2530",
  null
  
)

export default component.exports